export const PATTERN_CHAR = '#';
export const PATTERN_REGEX = new RegExp(PATTERN_CHAR);
export const PATTERN_REGEX_ALL = new RegExp(PATTERN_CHAR, 'g');

export function depatternize(value = '', options = {}) {
  const depatternized = String(value).replace(/\D/g, '');

  return options.integer ? parseInt(depatternized, 10) : depatternized;
}

export default function patternize(value = '', options = {}) {
  let numbers = String(value).match(/\d/g);

  if (!value || !numbers || !numbers.length) {
    return '';
  }

  const {
    format,
    bigFormat,
  } = options;

  let index = 0;
  let formatted = format || '';
  let chars = (formatted.match(PATTERN_REGEX_ALL) || '').length;

  if (bigFormat && numbers.length > chars) {
    chars = bigFormat.length;
    formatted = bigFormat;
  }

  numbers = numbers
    .join('')
    .slice(0, chars);

  for (let i = 0; i < numbers.length; i += 1) {
    index = formatted.indexOf(PATTERN_CHAR);
    formatted = formatted.replace(PATTERN_REGEX, numbers[i]);
  }

  formatted = formatted.slice(0, index + 1);

  return formatted;
}
